import { c as _c } from "react/compiler-runtime";
import type { ListNonMemberSuggestPolicyDto } from '__generated__/api/unauth';
import { Button } from '@common/components';
import { Image } from '@/components/client';
interface PolicyCardProps {
  policy: ListNonMemberSuggestPolicyDto;
  index: number;
  onClick?: () => void;
}
const AiSparkleIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0"><defs><linearGradient id="ai-gradient-poc" x1="0%" y1="0%" x2="100%" y2="100%" gradientTransform="rotate(125.96)"><stop offset="0%" stopColor="#33A6FF" /><stop offset="100%" stopColor="#6A00FF" /></linearGradient></defs><path d="M7.89 5.29C7.67 5.2 7.5 5.02 7.41 4.81L6.7 3.19C6.56 2.94 6.18 2.94 6.05 3.19L5.34 4.81C5.24 5.02 5.07 5.19 4.86 5.29L3.95 5.68C3.68 5.81 3.68 6.18 3.95 6.31L4.86 6.7C5.08 6.79 5.25 6.97 5.34 7.18L6.05 8.81C6.19 9.06 6.57 9.06 6.7 8.81L7.41 7.18C7.51 6.97 7.68 6.8 7.89 6.7L8.8 6.31C9.07 6.18 9.07 5.81 8.8 5.68L7.89 5.29Z" fill="url(#ai-gradient-poc)" /><path d="M19.18 10.166C18.53 9.88 18.01 9.34 17.74 8.68L15.59 3.61C15.2 2.8 14.05 2.8 13.66 3.61L11.51 8.68C11.23 9.34 10.71 9.88 10.07 10.166L7.35 11.4C6.55 11.79 6.55 12.96 7.35 13.35L10.07 14.584C10.72 14.87 11.24 15.41 11.51 16.07L13.66 21.14C14.05 21.95 15.2 21.95 15.59 21.14L17.74 16.07C18.02 15.41 18.54 14.87 19.18 14.584L21.9 13.35C22.701 12.96 22.701 11.79 21.9 11.4L19.18 10.166Z" fill="url(#ai-gradient-poc)" /><path d="M6.21 15.25C6.33 15.54 6.55 15.77 6.83 15.9L7.99 16.45C8.34 16.62 8.34 17.13 7.99 17.3L6.83 17.85C6.55 17.98 6.33 18.22 6.21 18.5L5.29 20.74C5.12 21.09 4.63 21.09 4.46 20.74L3.54 18.5C3.42 18.21 3.2 17.98 2.92 17.85L1.76 17.3C1.41 17.13 1.41 16.62 1.76 16.45L2.92 15.9C3.2 15.77 3.42 15.53 3.54 15.25L4.46 13.01C4.63 12.66 5.12 12.66 5.29 13.01L6.21 15.25Z" fill="url(#ai-gradient-poc)" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const PolicyCard = t0 => {
  const $ = _c(39);
  const {
    policy,
    index,
    onClick
  } = t0;
  const isLocked = index >= 3;
  const t1 = `${policy.policyName} 정책 상세 보기`;
  let t2;
  if ($[0] !== onClick) {
    t2 = e => e.key === "Enter" && onClick?.();
    $[0] = onClick;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== policy.agency || $[3] !== policy.agencyLogo) {
    t3 = <Image src={policy.agencyLogo} alt={policy.agency} width={20} height={20} className="size-20 rounded-pill border border-Gray-300" />;
    $[2] = policy.agency;
    $[3] = policy.agencyLogo;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== policy.agency) {
    t4 = <span className="font-600 text-Gray-500 typo-caption1">{policy.agency}</span>;
    $[5] = policy.agency;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex items-center gap-4">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = isLocked ? "\uCD5C\uB300 ??? \uC9C0\uC6D0" : policy.supportBenefit;
  let t7;
  if ($[10] !== t6) {
    t7 = <span className="rounded-xsmall bg-Gray-200 px-6 py-2 font-600 text-B-500 typo-caption1">{t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="flex items-center justify-between">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== policy.policyName) {
    t9 = <h3 className="line-clamp-2 font-600 text-Gray-black typo-body3">{policy.policyName}</h3>;
    $[15] = policy.policyName;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <div className="flex flex-col gap-12"><div className="flex flex-col gap-4">{t8}{t9}</div></div>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isLocked || $[21] !== policy.aiSummary) {
    t11 = isLocked ? <div className="flex items-center gap-8 rounded-small bg-Gray-25 p-12"><div className="flex flex-1 flex-col gap-4"><div className="flex items-center gap-8"><span className="inline-flex items-center gap-2 whitespace-nowrap"><AiSparkleIcon /><span className="bg-clip-text font-700 text-transparent typo-caption1" style={{
              background: "linear-gradient(125.96deg, #33A6FF -8.28%, #6A00FF 101.68%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}>AI 요약</span></span><div className="h-15 flex-1 rounded-xsmall bg-Gray-200" /></div><div className="h-15 rounded-xsmall bg-Gray-200" /></div><Button dimensions="H32" theme="secondary-fill">더보기</Button></div> : policy.aiSummary && <div className="rounded-small bg-Gray-25 p-12"><p className="line-clamp-2 font-400 text-Gray-600 typo-caption1"><span className="mb-2 mr-2 inline-flex items-center gap-2 whitespace-nowrap align-middle"><AiSparkleIcon /><span className="bg-clip-text font-700 text-transparent typo-caption1" style={{
            background: "linear-gradient(125.96deg, #33A6FF -8.28%, #6A00FF 101.68%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
          }}>AI 요약</span></span>{" "}{policy.aiSummary}</p></div>;
    $[20] = isLocked;
    $[21] = policy.aiSummary;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = isLocked ? "\uB9C8\uAC10 ????" : policy.expirationDate;
  let t13;
  if ($[23] !== t12) {
    t13 = <span className="font-700 text-Gray-900">{t12}</span>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = isLocked ? "???\uC77C \uC804 \uC5C5\uB370\uC774\uD2B8" : policy.daysAgo;
  let t15;
  if ($[25] !== t14) {
    t15 = <span className="font-600 text-Gray-500">{t14}</span>;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t13 || $[28] !== t15) {
    t16 = <div className="flex items-center justify-between typo-caption1">{t13}{t15}</div>;
    $[27] = t13;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t16) {
    t17 = <article className="flex flex-col gap-16 rounded-xxlarge bg-Gray-white px-24 py-28">{t10}{t11}{t16}</article>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== onClick || $[35] !== t1 || $[36] !== t17 || $[37] !== t2) {
    t18 = <div role="button" tabIndex={0} aria-label={t1} className="w-full cursor-pointer text-left" onClick={onClick} onKeyDown={t2}>{t17}</div>;
    $[34] = onClick;
    $[35] = t1;
    $[36] = t17;
    $[37] = t2;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
};